import './GuestAuthDropdown.scss';
import { useEffect, useState } from 'react';
import GuestLoginPanel from './GuestLoginPanel';

export default function GuestAuthDropdown({
  userIconSrc,
  label = 'Sign in',
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    const onPointerDown = (e) => {
      if (!e.target?.closest?.('.guest-auth')) setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('pointerdown', onPointerDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('pointerdown', onPointerDown);
    };
  }, [open]);

  return (
    <div className={`user-menu guest-auth ${open ? 'guest-auth--open' : ''}`} aria-label="Sign in">
      <button
        type="button"
        className="user-menu__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-label="Sign in"
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        {!!userIconSrc && <img src={userIconSrc} alt="user" className="user-menu__icon" />}
        <span className="user-menu__name">{label}</span>
      </button>

      {open ? (
        <div className="guest-auth__dropdown" role="presentation">
          <GuestLoginPanel
            showContinueAsGuest
            onGuestContinue={() => setOpen(false)}
          />
        </div>
      ) : null}
    </div>
  );
}
